import clsx from 'clsx'
import PropTypes from 'prop-types'

import styles from './editModal.module.scss'

/**
 * Karte im Bearbeiten-Fenster der Unterstützer:innen.
 *
 * Liegt bewusst in einer eigenen Datei und nicht in der Komponente, die sie
 * verwendet: React sieht eine im Rendern erzeugte Funktion als neuen Typ an —
 * die Eingabefelder darin würden bei jedem Tastendruck neu aufgebaut und der
 * Schreibzeiger spränge heraus.
 */
export default function Card({ title, hint, action, className, children }) {
	return (
		<section className={clsx(styles.card, className)}>
			{(title || action) && (
				<div className={styles.cardHead}>
					<div className={styles.cardHeadText}>
						{title && <h3 className={styles.cardTitle}>{title}</h3>}
						{hint && <p className={styles.cardHint}>{hint}</p>}
					</div>
					{action}
				</div>
			)}
			{children}
		</section>
	)
}

Card.propTypes = {
	title: PropTypes.node,
	hint: PropTypes.node,
	action: PropTypes.node,
	className: PropTypes.string,
	children: PropTypes.node
}
